import React from "react";
import Button from "../button/Button";
import { PaymentModelDetail } from "../../types-interfaces/types";

interface ModalConfirmProps {
  title: string;
  payments: Array<PaymentModelDetail>;
  confirmButtonText: string;
  handleConfirm: () => void;
  handleCloseModal: () => void;
}

const ModalConfirm: React.FC<ModalConfirmProps> = ({
  title,
  payments,
  confirmButtonText,
  handleConfirm,
  handleCloseModal,
}) => {
  return (
    <div className="update-payment-modal">
      <div className="title-div">
        <span className="title">{title}</span>
      </div>
      <div className="table-div" style={{maxHeight: "164px", overflowInline: "hidden"}}>
        <table className="update-payment-table">
          <thead className="update-payment-thead">
            <tr>
              <th className="update-payment-td-head">Rut Cliente</th>
              <th className="update-payment-td-head">Rut Pagador</th>
              <th className="update-payment-td-head">Monto</th>
              <th className="update-payment-td-head">Moneda</th>
            </tr>
          </thead>
          <tbody className="update-payment-tbody">
            {payments.map((payment, index) => 
              <tr key={index} className="update-payment-tr">
                <td className="update-payment-td-body">
                  {payment?.customerId}
                </td>
                <td className="update-payment-td-body">{payment?.payerId}</td>
                <td className="update-payment-td-body">
                  {payment?.amount.toLocaleString("es-CL", {
                    style: "currency",
                    currency: payment?.currencyType ?? "CLP",
                  })}
                </td>
                <td className="update-payment-td-body">
                  {payment?.currencyType}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="confirm-btn-div">
        <Button
          className="confirm-btn"
          text={confirmButtonText}
          onClick={() => handleConfirm()}
        />
        <Button
          className="cancel-btn"
          text="Cancelar"
          onClick={() => handleCloseModal()}
        />
      </div>
    </div>
  );
};

export default ModalConfirm;